// **Author:** Vijay 
import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Button, Box, Typography, Container, Paper, Avatar, Grid } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useAuth } from "../../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import Input from "../../components/Input";
import httpClient from "../../services/index.js";

const schema = yup.object().shape({
  email: yup.string().email("Invalid email").required("Email is required"),
  password: yup.string().required("Password is required"),
});

export default function Login() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  const { login } = useAuth();
  const [loading, setLoading] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState("");
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    setLoading(true);
    setErrorMsg("");
    try {
      // Get all customers and check credentials
      const res = await httpClient.get("/customers");
      if (res.success && Array.isArray(res.value)) {
        const user = res.value.find((u) => u.email === data.email && u.password === data.password);
        if (user) {
          login(user, "mock-token");
          setTimeout(() => {
            navigate("/admin/dashboard");
          }, 1000);
        } else {
          setErrorMsg("Invalid credentials");
        }
      } else {
        setErrorMsg("Login failed");
      }
    } catch (err) {
      setErrorMsg("Server error. Please try again later.");
    }
    setLoading(false);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #6B73FF 0%, #000DFF 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Container maxWidth="xs">
        <Paper elevation={6} sx={{ p: 4, borderRadius: 4 }}>
          <Grid container direction="column" alignItems="center" spacing={2}>
            <Grid item>
              <Avatar sx={{ bgcolor: "#000DFF", width: 56, height: 56 }}>
                <LockOutlinedIcon fontSize="large" />
              </Avatar>
            </Grid>
            <Grid item>
              <Typography variant="h5" fontWeight={700} color="#222" align="center">
                Welcome Back
              </Typography>
              <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 1 }}>
                Sign in to your account
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%" }}>
              <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate>
                {errorMsg && (
                  <Typography color="error" align="center" sx={{ mb: 2 }}>
                    {errorMsg}
                  </Typography>
                )}
                <Input
                  label="Customer ID"
                  type="email"
                  register={register("email")}
                  error={errors.email?.message}
                  fullWidth
                />
                <Input
                  label="Password"
                  type="password"
                  register={register("password")}
                  error={errors.password?.message}
                  fullWidth
                />
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  sx={{ mt: 3, py: 1.5, fontWeight: 600, fontSize: "1rem", borderRadius: 2 }}
                  disabled={loading}
                >
                  {loading ? "Logging in..." : "Login"}
                </Button>
                <Typography align="center" sx={{ mt: 2 }}>
                  Don't have an account?{" "}
                  <Link to="/register" style={{ color: "#000DFF", textDecoration: "underline" }}>
                    Register
                  </Link>
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
}
